import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';

export class FxLogo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var classNames = ['logo', 'fxLogo'];
    if (this.props.isPrimary) { classNames.push('primaryLogo'); }

    return (
      <svg className={classNames.join(' ')} viewBox="0 0 123 70" aria-labelledby='fx-logo-title' role='img'>
        <title id='fx-logo-title'>FX Logo</title>
        <path d="M5.5,5.4h107.2v52.9H5.5V5.4z M0,63.8h118.1V0H0V63.8z" />
        <path d="M5.5,5.4h107.2v52.9H5.5V5.4z M0,63.8h118.1V0H0V63.8z"
        />
        <polygon className="cls-2" 
          points="78.3,50.5 73,41.1 72.8,40.7 72.6,41.1 67.3,50.5 52.4,50.5 64.8,31.9 64.9,31.8  64.8,31.7 59.3,23.4 59.2,23.3 59.1,23.3 39.8,23.3 39.6,23.3 39.6,23.5 39.6,28.6 39.6,28.8 39.8,28.8 53,28.8 53,38.4  39.8,38.4 39.6,38.4 39.6,38.6 39.6,50.5 26.7,50.5 26.7,13.3 66.8,13.2 72.6,23.1 72.8,23.4 73,23.1 78.9,13.3 92.9,13.3  80.8,31.7 80.8,31.8 80.8,31.9 93.2,50.5"
        />
        <polygon
          points="78.3,50.5 73,41.1 72.8,40.7 72.6,41.1  67.3,50.5 52.4,50.5 64.8,31.9 64.9,31.8 64.8,31.7 59.3,23.4 59.2,23.3 59.1,23.3 39.8,23.3 39.6,23.3 39.6,23.5 39.6,28.6  39.6,28.8 39.8,28.8 53,28.8 53,38.4 39.8,38.4 39.6,38.4 39.6,38.6 39.6,50.5 26.7,50.5 26.7,13.3 66.8,13.2 72.6,23.1  72.8,23.4 73,23.1 78.9,13.3 92.9,13.3 80.8,31.7 80.8,31.8 80.8,31.9 93.2,50.5"
        />
      </svg>
    );
  }
}

TranslatedComponent(FxLogo);
export default FxLogo;




// WEBPACK FOOTER //
// ./client/src/components/logos/FxLogo.jsx